import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextHeaderEl = () => {
    return (
        <HighlightedText
            text="ΑΠΑΙΤΗΣΤΕ ΤΟ ΜΠΟΝΟΥΣ ΣΑΣ"
            highlights={[{ word: 'ΜΠΟΝΟΥΣ' }, { word: 'ΣΑΣ' }]}
            className={styles.text_header}
        />
    )
}

export const TextContentEl = () => {
    return (
        <HighlightedText
            text="μπόνους 325% + 400 δωρεάν περιστροφές"
            highlights={[{ word: '325%' }, { word: '+' }, { word: '400' }]}
            breakBeforeWords={['δωρεάν']}
            className={styles['text_content--FOURTH']}
        />
    )
}
